export const ProductAliases = {
  auto: 'auto',
  //bici: 'bici',
  funeraria: 'funeraria',
  //hogar: 'hogar',
  //vida: 'vida',
  //moto: 'moto',
  accidentes: 'accidentes',
  mascotas: 'mascotas',
  enfermedadesGraves: 'enfermedades-graves',
  //techHome: 'tech-home',
  //techMobile: 'tech-mobile',
  viajes: 'viajes',
} as const

export type ProductAliases = PropsTypesOf<typeof ProductAliases>

export const SubBranches = {
  servicioDeAsistencia: 'SERVICIO DE ASISTENCIA',
  ambulanciaAerea: 'AMBULANCIA AEREA',
  autoVoluntario: 'AUTO VOLUNTARIO',
  motoVoluntario: 'MOTO VOLUNTARIO',
  autoexceso: 'AUTOEXCESO',
  seguroDeDesempleo: 'SEGURO DE DESEMPLEO',
  fianzasParaLicitacion: 'FIANZAS PARA LICITACION',
  prestamoHipotecario: 'PRESTAMO HIPOTECARIO',
  prestamoConsumo: 'PRESTAMO CONSUMO',
  prestamoVehiculo: 'PRESTAMO VEHICULO',
  asistenciaTc: 'ASISTENCIA TC',
  lineaDeCreditoFlexible: 'LINEA DE CREDITO FLEXIBLE',
  cuentaDeAhorro: 'CUENTA DE AHORRO',
  prestamoIncendio: 'PRESTAMO INCENDIO',
  todoRiesgoConstrucciones: 'TODO RIESGO CONSTRUCCIONES',
  averiaDeMaquinarias: 'AVERIA DE MAQUINARIAS',
  todoRiesgoEquipoElectronico: 'TODO RIESGO EQUIPO ELECTRONICO',
  incendioVoluntario: 'INCENDIO VOLUNTARIO',
  garantiaDeElectrodomesticos: 'GARANTIA DE ELECTRODOMESTICOS',
  mascotasIndividual: 'MASCOTAS INDIVIDUAL',
  indemnizacionPorHospitalizacion: 'INDEMNIZACION POR HOSPITALIZACION',
  accidentesPersonales: 'ACCIDENTES PERSONALES',
  asistenciaFuneraria: 'ASISTENCIA FUNERARIA',
  enfermedadesGraves: 'ENFERMEDADES GRAVES',
  saludMujer: 'SALUD MUJER',
  vidaIndividual: 'VIDA INDIVIDUAL',
  vidaConAhorro: 'VIDA CON AHORRO',
  indemnizacionPorCancer: 'INDEMNIZACION POR CANCER',
  responsabilidadCivil: 'RESPONSABILIDAD CIVIL',
  saludIndividual: 'SALUD INDIVIDUAL',
  saludColectivo: 'SALUD COLECTIVO',
  saludDental: 'SALUD DENTAL',
  saludVisual: 'SALUD VISUAL',
  seguroDeViajes: 'SEGURO DE VIAJES',
}

export const ArgentoInsurancePaymentPeriodicities = {
  unique: {
    text: 'Pago unico',
    value: 'unique',
    id: 0,
  },
  monthly: {
    text: 'Mensual',
    value: 'monthly',
    id: 1,
  },
  bimonthly: {
    text: 'Bimestral',
    value: 'bimonthly',
    id: 2,
  },
  quarterly: {
    text: 'Trimestral',
    value: 'quarterly',
    id: 3,
  },
  fourMonthly: {
    text: 'Cuatrimestral',
    value: 'fourMonthly',
    id: 4,
  },
  semiannual: {
    text: 'Semestral',
    value: 'semiannual',
    id: 6,
  },
  yearly: {
    text: 'Anual',
    value: 'yearly',
    id: 12,
  },
  manual: {
    text: 'Captura manual',
    value: 'manual',
    id: 99,
  },
} as const
